export default {
  title: {
    id: 'product_jp_product_condition_title',
    defaultMessage: 'Product condition',
  },
  caption: {
    id: 'product_jp_product_condition_caption',
    defaultMessage: 'Product feature',
  },
  paragraph: {
    id: 'product_jp_product_condition_paragraph',
    defaultMessage:
      '"Product condition" refers to the appearance of the device, such as the body and screen. While the condition and price vary by grade, all products are guaranteed to function 100% properly, with no difference in performance.',
  },
}
